import { isTruthy } from '../../util/is-truthy';

export const ndjsonParser = (value: Uint8Array | undefined) => {
  const parsed = new TextDecoder('utf-8').decode(value);
  return parsed
    .split('\n')
    .filter(isTruthy)
    .map((jsonString) => JSON.parse(jsonString));
};
